import {useIntl} from 'react-intl';
import {localeToPath} from '../utils/localeToPath';
import {LocaleEnum} from '../types/locale';
import {forceTrailingSlash} from '../utils/urlUtils';

export const useLocalizedUrl = (): ((url: string) => string) => {
  const intl = useIntl();

  const localize = url => {
    // remove leading slashes
    url = url.replace(/^\/+/g, '');

    return forceTrailingSlash(`/${localeToPath(intl.locale as LocaleEnum)}/${url}`);
  };

  return localize;
};
